import { useEffect, useState } from 'react';

import { fetchApi } from '~/api/core';

import { type GlobalConfigFooter, type GlobalConfigHeader, ZodGlobalConfig } from '../api/global-config';

export function useGetCachedGlobalConfig() {
  const [isLoading, setIsLoading] = useState(true);
  const [globalConfigHeader, setGlobalConfigHeader] = useState<GlobalConfigHeader>();
  const [globalConfigFooter, setGlobalConfigFooter] = useState<GlobalConfigFooter>();
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    const getCachedGlobalConfig = async () => {
      try {
        const globalConfig = await fetchApi('/global-config', undefined, ZodGlobalConfig);
        setGlobalConfigHeader(globalConfig.header);
        setGlobalConfigFooter(globalConfig.footer);
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };
    getCachedGlobalConfig();
  }, []);

  return { isLoading, globalConfigHeader, globalConfigFooter, error };
}
